import { LegalPolicyModel } from './legal-policy.model';
import { PrivacyInfoModel } from './privacy-info.model';

export class FooterModel {
  constructor() {
    this.legalPolicy = [];
  }
  public copyRightInfo: undefined | null | string;
  public legalPolicy: undefined | null | Array<LegalPolicyModel>;
  public privacyInfo: undefined | null | PrivacyInfoModel;
}
